import React from "react";
import MidImage from "../../assets/images/Home/RANGE-01.png";

const ImageSection = () => {
    return (
        <section className="image-section" style={{ padding: "40px 0" }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <img
                            src={MidImage}
                            alt="Arch Elevators"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImageSection;
